import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DialogService } from 'src/app/services/dialog.service';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';
import { Subscription } from 'rxjs';
import { SearchFieldService } from 'src/app/services/search-filed.service';

@Component({
    selector: 'form-view-search',
    templateUrl: './form-view-search.component.html',
    styleUrls: ['./form-view-search.component.css'],
    standalone: false
})
export class FormViewSearchComponent implements OnInit, OnChanges {

  @Input()config:columnsDef;
  @Input()configRef:columnsDef;
  @Input()arrayColumnsDef:columnsDef[];
  @Input()group: UntypedFormGroup;
  showBuscaDados:boolean = true;
  row: Object;
  componentHidden:Boolean = false;
  @Input() entityName:string = "";
  @Input() entityDesc:string;
  @Input() public entityNameDesc:string = "";
  @Output() editEvent:EventEmitter<boolean> = new EventEmitter();
  disableButton = false;
  sub:Subscription;
  tabindex:string;
  @Input() public customCondition:string="";
  canConfig:boolean = false;
  toolTipText = null;
  
  constructor( private dialogServices:DialogService, public dynamicServices:DynamicFormsService,
    private searchServices:SearchFieldService, private cd:ChangeDetectorRef) { }
  
  
  ngOnChanges(changes: SimpleChanges): void { 
    this.editEvent.next(true);
  }

  ngOnInit() {  
      
      if ( this.group.get(this.config.COLUMNNAME).disabled ){
        this.disableButton =true;
      }else{
        this.disableButton =false;
      }
      
  }


  @Output() blurEvent:EventEmitter<boolean> = new EventEmitter();
  bluring(event){
      this.blurEvent.next(event)
  }

  onChange(){
    this.dynamicServices.editingRow = true;
    this.dynamicServices.enableSave = true;

  }

  ngOnDestroy(){
    if (this.sub!= null ) {this.sub.unsubscribe();}
  }


  
  editing(){
    this.editEvent.next(true)
  }
  
  openSearchForm(){
    this.dialogServices.openFindDialog(this.entityName,this.entityNameDesc,this.dynamicServices,this.group,this.configRef,(value)=>{
        
        let ob = JSON.parse(JSON.stringify(value));
        
        
        if ( this.config.REFERENCES != null && this.config.DATATYPE!="SEARCHREFERENCE"){
          this.config.REFERENCES.forEach( data=>{

            this.group.get(this.config.COLUMNNAME).setValue(ob[data.CONSTRAINT_COLUMN_REF],{onlySelf:true,emitEvent:false});
            
            let descColumnName = this.configRef.COLUMNNAME.split("->")[1];
            Object.keys(ob).forEach(valueKey=>{
              try{
                if ( valueKey == descColumnName){
                    this.group.get(this.configRef.COLUMNNAME).setValue(ob[valueKey],{onlySelf:true,emitEvent:false});
                }
              }catch(Exception){
              }
            })

            
            // fazendo chave composta //
            this.arrayColumnsDef.forEach(linhas=>{
                if ( linhas.REFERENCES != null && linhas.REFERENCES.length > 0 && linhas.COLUMNNAME != this.config.COLUMNNAME && linhas.COLUMNNAME != this.configRef.COLUMNNAME ){
                  let arraysRefs =  linhas.REFERENCES.filter(x=> x.CONSTRAINT_NAME == data.CONSTRAINT_NAME );
                  let refColName = linhas.COLUMNNAME;
                  arraysRefs.forEach( linha =>{
                    //if ( !ObjectUtil.isNotEmpty(this.group.get(refColName).value)  ){
                      this.group.get(refColName).setValue(ob[linha.CONSTRAINT_COLUMN_REF],{onlySelf:true,emitEvent:false});
                      
                      let valor = null;
                      linhas.REFERENCES.forEach( ref=>{
                          let ka = Object.keys(ob).filter(k=>k.split("->")[0] == ref.CONSTRAINT_NAME);
                          if (ka.length > 0 ){
                            valor = ob[ka[0]];
                          }
                      });
                      Object.keys(this.group.controls).forEach( control=>{
                          
                            if ( control.indexOf("->") > -1 ){
                              for ( let l of this.arrayColumnsDef){
                                if ( l.VALIDATIONERROR != null ){
                                  if( l.COLUMNNAME.indexOf("->")>-1){
                                    let colName = JSON.parse(l.VALIDATIONERROR)['ColumnName'];
                                    if ( l.COLUMNNAME.indexOf('->') > -1 && l.COLUMNNAME == control && colName == refColName){
                                      this.group.get(control).setValue(valor);
                                    }
                                  }
                                }
                              }
                              
                          }  
                      })
                      
                    //}
                  });
                }
            });
          });
        }
        
        if ( this.config.DATATYPE == "SEARCHREFERENCE"){
            let refField:String = this.config.refName != null ? this.config.refName : this.config.COLUMNNAME.split("->")[0];
            
            if ( this.config.headerName != null ){
              this.group.get(this.config.headerName).patchValue(ob[refField.toString()]);
            }else{
              this.group.get(this.config.COLUMNNAME.split("->")[0]).patchValue(ob[refField.toString()]);
            }            
            this.group.get(this.config.COLUMNNAME).patchValue(ob[this.config.COLUMNNAME.split("->")[1]]);
        }


        this.editEvent.next(true);

    },this.customCondition)
  }

  

  onFocus(event:FocusEvent){
    this.searchServices.updateDesription(this.entityName,this.config,this.configRef,this.group,this.customCondition,this.dynamicServices,this.editEvent);      
  }

  ngAfterViewInit(){
    this.cd.detectChanges();
  }
  
}
